export default __webpack_public_path__ + "static/media/verify.1ec6135c.svg";